export { default as CustomResourceList } from './CustomResourceList';
